import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { AGGREGATE_AUDIT_EVENTS, FETCH_AUDIT_LOGS } from './actionTypes'

export const fetchAuditLogs = (search: object): AppThunk => {
  return dispatch => dispatch(request('/logs', FETCH_AUDIT_LOGS, { search }, { service: 'audit' }))
}

export const aggregateAuditEvents = (): AppThunk => {
  return dispatch => dispatch(request('/events/aggregate', AGGREGATE_AUDIT_EVENTS, {}, { service: 'audit' }))
}
